export const getAdditionalTaxTypeApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
   return `additional-tax-settings${queryString ? `?${queryString}` : ""}`;
};

export const addAdditionalTaxTypeApi = () => {
    return `/additional-tax-settings`;
};

export const  updateAdditionalTaxTypeApi = (params) => {
    return `/additional-tax-settings/${params?.asset_slug}`;
};

export const  deleteAdditionalTaxTypeApi = (params) => {
    return `/additional-tax-settings`;
};